
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.157 2.687H2.59A1.59 1.59 0 001 4.277V15.41A1.59 1.59 0 002.59 17h11.133a1.59 1.59 0 001.59-1.59V9.842","stroke":"#AAB4C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.12 1.494a1.687 1.687 0 112.386 2.386l-7.554 7.554-3.18.795.794-3.18 7.554-7.555z","stroke":"#AAB4C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    